import React, { useEffect, useState } from 'react';
import { RobRowStyle, RobRowDataStyle } from './BunkerRob.styles';
import { FuelROB } from 'src/types/ViewModel/Bunkering/FuelROB';
import { FuelRobVM } from 'src/types/ViewModel/Bunkering/FuelRobVM';
import { hasConsOrLossForTankAndBunkering } from '../BunkeringUtils';

interface PreviousRobRowProps {
    tankId: number;
    fuelRobVM: FuelRobVM;
    previousRobs: FuelROB[];
}

const PreviousRobRows: React.FC<PreviousRobRowProps> = ({ tankId, fuelRobVM, previousRobs }) => {
    const [fuelRobsForTank, setFuelRobsForTank] = useState<FuelROB[]>([]);

    useEffect(() => {
        setFuelRobsForTank(
            fuelRobVM?.fuelRobColumns?.[fuelRobVM?.fuelRobColumns?.length - 1]?.fuelRobs
                ?.filter((rob) => rob.tankId === tankId)
                ?.sort((a, b) => a.bunkeringGuid.localeCompare(b.bunkeringGuid))
        );
    }, [fuelRobVM]);

    if (!fuelRobsForTank || fuelRobsForTank.length === 0) {
        return <RobRowStyle key={`${tankId}_rob`}></RobRowStyle>;
    }

    return (
        <>
            {fuelRobsForTank?.map((rob, i) => {
                let displaySumRowForMixedTank = false;
                if (i === fuelRobsForTank.length - 1 && fuelRobsForTank.length > 1) displaySumRowForMixedTank = true;
                const previousRob = previousRobs?.find((_rob) => _rob.tankId === tankId && rob.bunkeringGuid === _rob?.bunkeringGuid);
                if (previousRob) {
                    return (
                        <div key={`${tankId}_${previousRob.bunkeringGuid}_${previousRob?.noonReportId}_prevrob`}>
                            <RobRowStyle
                                key={`${tankId}_${previousRob.bunkeringGuid}_prevrob_s`}
                                hasConsumption={hasConsOrLossForTankAndBunkering(tankId, rob.bunkeringGuid, fuelRobVM)}
                            >
                                <RobRowDataStyle>{previousRob.rob}</RobRowDataStyle>
                            </RobRowStyle>
                            {displaySumRowForMixedTank && <RobRowStyle key={`${tankId}_prevRob_sum_row`}></RobRowStyle>}
                        </div>
                    );
                } else {
                    return (
                        <div key={`${tankId}_${rob.bunkeringGuid}_${rob?.noonReportId}_prevrob`}>
                            <RobRowStyle></RobRowStyle>
                            {displaySumRowForMixedTank && <RobRowStyle key={`${tankId}_prevRob_sum_row`}></RobRowStyle>}
                        </div>
                    );
                }
            })}
        </>
    );
};

export default PreviousRobRows;
